<template>
  <div>
    <div>
      <img src="http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/tel_green.png" alt="" style="height: 18px;marign-right:4px;vertical-align: middle;">
      {{userInfo}}
    </div>
  </div>
</template>

<script>
  import {dataDst} from "../../common/util"

  export default {
    name: "kz-phone",
    props:{
      phone:{
        type:Object,
      },
      encryption:{
        type:Boolean,
      }
    },
    data(){
      return{
        modalShow:true,
        phoneText:'',
      }
    },
    computed:{
      userInfo(){
        if(this.encryption){
          this.phoneText = dataDst(this.phone.row.kzphone)
        }else{
          this.phoneText = this.phone.row.kzphone
        }
        return this.phoneText
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/render-components/render-phone.vue